import React from 'react';

/**
 * Encabezado de sección del rediseño: eyebrow (mono uppercase) + título serif
 * con la última palabra en itálica azul (#6FA0FF) — la firma de marca del diseño.
 */
const SectionHead = ({ eyebrow, title, accent, align = 'center', subtitle, maxWidth = 640 }) => (
  <div className="reveal" style={{ textAlign: align, maxWidth: align === 'center' ? maxWidth : 'none', margin: align === 'center' ? '0 auto' : 0 }}>
    {eyebrow && (
      <p style={{ font: "600 .82rem 'IBM Plex Mono'", letterSpacing: '.14em', textTransform: 'uppercase', color: 'var(--label)', margin: 0 }}>{eyebrow}</p>
    )}
    <h2 style={{ font: "600 clamp(2rem,4.5vw,3.1rem)/1.05 'Source Serif 4'", letterSpacing: '-.02em', color: 'var(--heading)', margin: '12px 0 0', textWrap: 'balance' }}>
      {title}{accent ? <> <span style={{ fontStyle: 'italic', color: '#6FA0FF' }}>{accent}</span></> : null}
    </h2>
    {subtitle && (
      <p style={{ font: "400 1.08rem/1.6 'Hanken Grotesk'", color: 'var(--muted)', margin: '14px auto 0', maxWidth: 620 }}>{subtitle}</p>
    )}
  </div>
);

export default SectionHead;
